import React from "react";
import { useNavigate } from 'react-router-dom';
import './Login.css'
import { useState, useEffect } from 'react';
import { GetLogin } from "../Services/AuthService";
import SpinnerModal from "../../ShareComponent/Spinner/SpinnerModal";
import { toast } from 'react-toastify';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ Email: "", Password: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    // Check if already logged in
    useEffect(() => {
        const token = sessionStorage.getItem('token');
        if (token) {
            navigate('/Home/Dashboard');
        }
    }, [navigate]);

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Clear error when user types
        if (error) {
            setError("");
        }
    }

    const FormSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!formData.Email || !formData.Password) {
            setError("Please enter both email and password");
            toast.error("Please enter both email and password");
            return;
        }

        try {
            setIsLoading(true);
            setError("");
            
            const response = await GetLogin(formData);
            
            if (response.token) {
                sessionStorage.setItem("token", response.token);
                
                // Store basic user info (you can enhance this by getting user details from API)
                const userInfo = {
                    email: formData.Email,
                    loginTime: new Date().toISOString()
                };
                sessionStorage.setItem("user", JSON.stringify(userInfo));
                
                toast.success("Login successful!");
                
                // Navigate to dashboard
                setTimeout(() => {
                    navigate('/Home/Dashboard');
                }, 500);
            } else {
                throw new Error("No token received from server");
            }
        } catch (error) {
            console.error("Login failed:", error);
            const errorMessage = error.message || "Login failed. Please check your credentials.";
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {isLoading && <SpinnerModal isLoading={true} />}
            <div className="login-container">
                <div className="login-background">
                    <div className="login-card fade-in">
                        <div className="login-header">
                            <div className="pharmacy-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M9 22V12H15V22" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h1 className="login-title">E-Commerce Admin</h1>
                            <p className="login-subtitle">Sign in to your admin account</p>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert" style={{ 
                                padding: '10px 15px', 
                                marginBottom: '20px', 
                                borderRadius: '4px', 
                                backgroundColor: '#f8d7da', 
                                color: '#721c24',
                                border: '1px solid #f5c6cb'
                            }}>
                                {error}
                            </div>
                        )}

                        <form className="login-form" onSubmit={FormSubmit}>
                            <div className="form-group">
                                <label className='common-Labels' htmlFor="email">Email Address</label>
                                <input
                                    className="common-Input"
                                    id='email'
                                    name='Email'
                                    type="email"
                                    placeholder="Enter your email"
                                    required
                                    value={formData.Email}
                                    onChange={onChange}
                                    disabled={isLoading}
                                    autoComplete="email"
                                />
                            </div>

                            <div className="form-group">
                                <label className='common-Labels' htmlFor="password">Password</label>
                                <input
                                    className="common-Input"
                                    type="password"
                                    id='password'
                                    name='Password'
                                    placeholder="Enter your password"
                                    required
                                    value={formData.Password}
                                    onChange={onChange}
                                    disabled={isLoading}
                                    autoComplete="current-password"
                                />
                            </div>

                            <div className="form-options">
                                <label className="remember-me">
                                    <input type="checkbox" />
                                    <span>Remember me</span>
                                </label>
                                <a href="#" className="forgot-password" onClick={(e) => { e.preventDefault(); toast.info("Contact administrator to reset password"); }}>Forgot password?</a>
                            </div>

                            <button
                                type="submit"
                                className="common-button primary login-button"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Signing in...' : 'Sign In'}
                            </button>
                        </form>

                        <div className="login-footer">
                            <p>Don't have an account? <a href="#" onClick={(e) => { e.preventDefault(); toast.info("Contact administrator to create an account"); }}>Contact Administrator</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login